<template>
	<div :class="{ switcher: true, flipped: !!flipped }" @click="clicked" :title="title">
		<h4
			:class="{
				'switcher-label': true,
				clickable: typeof switcherLabel2 !== 'undefined' && switcherLabel2 !== '',
				labelWidthAuto: !!labelWidthAuto,
			}"
			@click="changeIt(null, false)"
			v-html="switcherLabel"
			v-if="switcherLabel && switcherLabel !== ''" />
		<span :class="{ bar: true, on: content, switchColour: typeof sameColour === 'undefined' || sameColour === false }" @click="changeIt"></span>
		<h4
			:class="{ 'switcher-label2': true, clickable: true, labelWidthAuto: !!labelWidthAuto }"
			v-if="switcherLabel2 && switcherLabel2 !== ''"
			@click="changeIt(null, true)"
			v-html="switcherLabel2" />
	</div>
</template>

<script>
import { computed, getCurrentInstance } from "vue";

export default {
	name: "Switcher",
	emits: ["input", "update:modelValue", "clicked"],
	props: {
		value: {
			type: [Boolean, String, Number],
			default: undefined,
		},
		modelValue: {
			type: [Boolean, String, Number],
			default: undefined,
		},
		switcherLabel: String,
		switcherLabel2: String,
		sameColour: [Boolean, String],
		title: String,
		flipped: Boolean,
		alwaysToggle: Boolean,
		labelWidthAuto: Boolean,
	},
	setup(props, { emit }) {
		// Computed property for unified value handling (Vue 3 v-model compatibility)
		const content = computed(() => {
			return props.modelValue !== undefined ? props.modelValue : props.value;
		});

		// Helper function to emit both input and update:modelValue for compatibility
		const emitValue = (newValue) => {
			emit("input", newValue);
			emit("update:modelValue", newValue);
		};

		const changeIt = (e, val) => {
			if (typeof val !== "undefined" && typeof props.switcherLabel2 !== "undefined" && !props.alwaysToggle) return;
			if (typeof val === "undefined" || !!props.alwaysToggle) val = !content.value;
			emitValue(val);
		};

		const clicked = (e) => {
			e.stopPropagation();
			emit("clicked", e);
		};

		return {
			content,
			changeIt,
			clicked,
		};
	},
};
</script>
<style lang="less" scoped>
@import "./../assets/css/less/_helper.less";
@import "./../assets/css/less/_settings.less";

.switcher {
	display: inline-block;
	vertical-align: top;
	margin: 4px 15px 0 0;
	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Safari */
	-khtml-user-select: none; /* Konqueror HTML */
	-moz-user-select: none; /* Old versions of Firefox */
	-ms-user-select: none; /* Internet Explorer/Edge */
	user-select: none;

	.switcher-label,
	.switcher-label2 {
		font-size: 14px;
		display: inline-block;
		font-weight: normal;
		vertical-align: top;
		padding-top: 2px;
		text-align: right;
		width: 55px;

		&.clickable {
			cursor: pointer;
		}

		&.labelWidthAuto {
			width: auto;
		}
	}

	.switcher-label2 {
		padding-left: 3px;
		text-align: left;
	}

	.bar {
		position: relative;
		display: inline-block;
		background: @borderRoseSubtle;
		.rounded(50px);
		width: 40px;
		height: 24px;
		cursor: pointer;
		margin-left: 3px;
		.trans(all 0.1s linear);

		&:before {
			content: " ";
			position: absolute;
			.rounded(50px);
			background-color: @guidedRose;
			width: 18px;
			height: 18px;
			left: 4px;
			top: 3px;
			z-index: 1;
			.trans(all 0.1s linear);
		}

		&.on {
			&:before {
				left: 18px;
			}

			&.switchColour {
				&:before {
					background-color: @guidedRose;
				}
			}
		}
	}

	&.flipped {
		.switcher-label,
		.switcher-label2 {
			color: #fff;
		}

		.bar {
			background: #fff;

			&.on {
				background: #fff;
			}

			&:before {
				background-color: @darkContrast;
			}
		}
	}

	&.multi {
		.bar {
			width: 200px;
		}
	}
}
</style>